export default __webpack_public_path__ + "images/518bb2ac19dfde8b255161ec109eaf06-st_patricks_day_small.webp";